import {
  SensorButtonNodeType,
  SensorBuzzerNodeType,
  SensorTouchNodeType,
  SensorTrihowSpecificNodeType,
} from '../Nodes/types';

export function findLanguageAnyNodes(nodes: any[]): {
  languageAnyTrihows: SensorTrihowSpecificNodeType[];
  languageAnyButtons: SensorButtonNodeType[];
  languageAnyBuzzers: SensorBuzzerNodeType[];
  languageAnyTouches: SensorTouchNodeType[];
} {
  return {
    languageAnyTrihows: nodes.filter(
      (node) =>
        node.type === 'sensor-nfcSpecific' &&
        node.data?.options?.language === null,
    ),
    languageAnyButtons: nodes.filter(
      (node) =>
        node.type === 'sensor-button' && node.data?.options?.language === null,
    ),
    languageAnyBuzzers: nodes.filter(
      (node) =>
        node.type === 'sensor-buzzer' && node.data?.options?.language === null,
    ),
    languageAnyTouches: nodes.filter(
      (node) =>
        node.type === 'sensor-touch' && node.data?.options?.language === null,
    ),
  };
}
